const getInitialState = () => ({
    openRequests: [],
    failedRequests: [],
    updatedAt: 0,
    pseudonyms: {
        entries: {},
        maxCount: 0,
    },
    lastInteractiveId: null,
});

export default {
    getInitialState
};
